import React, { useState } from 'react';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { __MessageTypes } from '../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_GetList, _global_buttonStyles } from '../../../common/ObjectStructures/Trasnversal';
import {  isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../common/Helpers';
import MessageBox from '../../../components/Common/Message/MessageBox';
import PropTypes from 'prop-types';
import { DatePicker, Icon, SpinnerSize, Toggle, TooltipHost } from '@fluentui/react';
import CValidator from '../../../components/Common/CValidator';
import { CalendarCustomInput } from '../../../common/CommonFuctions';
import { cloneDeep } from 'lodash-es';
import { useGetListObligationContracts } from '../../../hooks/services/sCO/useOfObligacion';
import { addListObligationContracts } from '../../../services/sCO/obligationElement.service';
import Loading from '../../../components/Templates/Site/Loading';

const SidePanelVinculateObligation = (props) => {
    const { t } = useTranslation();

    const { 
        inputParam_IsPanelOpen = null,
        inputParam_EditMode = false,
        inputParam_SetterIsPanelOpen = null,
        inputParam_ObligationName = null,
        inputParam_ObligationId = null,
        inputParam_ObligationHasSubLegalEntity = false,
    } = props;

    const [fechaPrimerVencimientoGlobal, setFechaPrimerVencimientoGlobal] = useState(null)
    const [isSaving, setIsSaving] = useState(false);

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [forceGetContracts, setForceGetContracts] = useState(true)
    
    const [filterText, setFilterText] = useState('')
    const [objContractListFiltred, setObjContractListFiltred] = useState(__OBJECT_STRUCTURE_GetList(999999, null))
    const [objContractList, setObjContractList] = useState(__OBJECT_STRUCTURE_GetList(999999, null))
    useGetListObligationContracts(inputParam_ObligationId, objContractList, setObjContractList, setObjContractListFiltred, inputParam_IsPanelOpen && inputParam_ObligationHasSubLegalEntity, forceGetContracts, setForceGetContracts)

    const validateForm = () => {
        let isValid = (
            objContractList.data !== null &&
            objContractList.data !== undefined
        ) ? true : false;

        return isValid
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null);
    };

    const prepareObjectsToSend = (objects) => {
        let objectsToSave = [];
        objects.forEach(element => {
            element.contractName = "";
            element.fechaPrimerVencimiento = element.fechaPrimerVencimiento === null ? null : element.fechaPrimerVencimiento;
            objectsToSave.push(element)
        });

        return objectsToSave;
    };

    const onEditItem = () => {
        if (validateForm()) { 
            const old_data = cloneDeep(objContractList.data);

            const aux_objectToSend = old_data.filter(x => (x.activa === true && (x.fechaPrimerVencimiento !== '')) || ((x.activa === undefined) && x.fechaPrimerVencimiento !== null))

            const aux_titles = []
            aux_objectToSend.map(x => {
                aux_titles.push({elementId: x.elementId, obligationId: x.obligationId, contractName: x.contractName})
            })

            const objectsToSend = prepareObjectsToSend(aux_objectToSend);

            setIsSaving(true);
            addListObligationContracts(inputParam_ObligationId, objectsToSend).then((response) => {
                setIsSaving(false);

                if (response.data.succeeded) {
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                setIsSaving(false);
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-requireddatanotset'))
        }
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const handleDateChange = (value, elementId) => {
        if (isNullUndefined(elementId)) {
            setFechaPrimerVencimientoGlobal(value);
            objContractList.data.forEach(item => {
                item.fechaPrimerVencimiento = !isNullUndefinedOrEmpty(value) ? value : null
                item.initialValFired = true
            });  
        }
        else {
            objContractList.data.forEach(item => {
                if (item.elementId === parseInt(elementId)) {
                    item.fechaPrimerVencimiento = !isNullUndefinedOrEmpty(value) ? value : null
                    item.initialValFired = true
                }
            });            
        }
    };

    const onRenderHeader = () => {
        return (
            <Row className='ms-2'>
                <Col xl={12}>
                    <h4 style={{ margin: 0 }}>{t('data-lang-boxname-vinculatecontracts')}</h4>
                </Col>
                <Col xl={12} className="pt-5">
                    <div className='border-bottom h5'>{inputParam_ObligationName}</div>
                </Col>
                <Col xl={12} className='pt-3'>
                    <Row className='pb-3'>
                        <Col className='col-auto text-start'><b>{t('data-lang-lbl-filter')}</b></Col>
                        <Col className='text-end'>
                            <input type='text' className='w-100' value={filterText} onChange={onChangeFilterText} />
                        </Col>
                    </Row>
                    <Row>
                        <Col className='col-auto text-start'><b>{t('data-lang-lbl-contractlist')}</b></Col>
                        <Col></Col>
                        <Col className='col-auto text-end'><b>{`${t('data-lang-lbl-firstduedate')} / ${t('data-lang-lbl-associate')}`}</b></Col>
                    </Row>
                </Col>
            </Row>
        );
    };

    const onRenderFooterContent = () => {
        const cheched = objContractList.data !== null && (objContractList.data.length ===  objContractList.data.filter(x => x.activa).length || objContractList.data.filter(x => x.activa).length === objContractList.data.length);
        return  <Row>
                    <Col xl={12}>
                        <Row className="pt-3 pe-0">
                            <Col>
                            </Col>
                            <Col>
                            {
                                cheched &&
                                <>
                                    <DatePicker
                                        value={!isNullUndefinedOrEmpty(fechaPrimerVencimientoGlobal) ? new Date(fechaPrimerVencimientoGlobal) : null }
                                        onSelectDate={(date) => handleDateChange(date, null)}
                                        width={"100%"}
                                        formatDate={onFormatDate}
                                        styles={{ root: { width: '100%' } }}
                                        customInput={ <CalendarCustomInput icon={<Icon iconName='Calendar' />} /> }
                                    />
                                    <CValidator
                                        isInValid={(!isNullUndefinedOrEmpty(cheched) ? isNullOrEmpty(fechaPrimerVencimientoGlobal) : false)}
                                        isInvalidText={"Error"}
                                    />
                                </>
                            }
                            </Col>
                            <Col className='col-auto me-auto'>
                                {
                                    objContractList.data !== null &&
                                    <Toggle
                                        label={ objContractList.data.length ===  objContractList.data.filter(x => x.activa).length || objContractList.data.filter(x => x.activa).length === objContractList.data.length ? t('data-lang-lbl-all') : t('data-lang-lbl-nothing') }
                                        checked={ objContractList.data.length ===  objContractList.data.filter(x => x.activa).length || objContractList.data.filter(x => x.activa).length === objContractList.data.length }
                                        onChange={() => onChangeAllAssociateConsolidation()}
                                        className="my-auto"
                                        styles={ { container:{ paddingTop: "4px" }, root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                    />
                                }
                            </Col>
                        </Row>
                    </Col>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12} className='d-flex'>
                        {
                            inputParam_EditMode && inputParam_ObligationHasSubLegalEntity && !isSaving &&
                            <PrimaryButton onClick={ onEditItem } styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>
                        }
                        {
                            isSaving &&
                            <Loading
                                inputParam_ShowLoading={true}
                                inputParam_ShowText={false}
                                inputParam_Width={'25px'}
                                inputParam_Height={'25px'}
                                inputParam_Left={""}
                                inputParam_Style={{marginTop: 0}}
                                inputParam_ColClassName={"me-2"}
                                inputParam_MarginLeft={""}
                                inputParam_SpinnerSize={SpinnerSize.medium} />
                        }
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    };

    const onChangeAssociateConsolidation = (contract) => {
        objContractList.data.forEach(item => {
            if (item.elementId === contract.elementId) {
                item.activa = item.canDelete ? !contract.activa : item.activa;
                item.fechaPrimerVencimiento = item.activa === true ? ((item.fechaPrimerVencimiento !== null) ? item.fechaPrimerVencimiento : null) : null;
                item.initialValFired = false
            }
        });

        setObjContractList && setObjContractList(prevState => ({
            ...prevState,
            data: objContractList.data,
            fireUpdate:true
        }))
    };

    const onChangeAllAssociateConsolidation = () => {
        let allChecked = (objContractList.data.filter(x => x.activa).length === objContractList.data.length);
        
        objContractList.data.forEach(item => {
            item.activa = item.canDelete ? !allChecked : item.activa;
            item.fechaPrimerVencimiento = item.activa === true ? ((item.fechaPrimerVencimiento !== null) ? item.fechaPrimerVencimiento : null) : null;
            item.initialValFired = false
        });

        setFechaPrimerVencimientoGlobal(null);
        
        setObjContractList && setObjContractList(prevState => ({
            ...prevState,
            data: objContractList.data,
            fireUpdate:true
        }))
    };

    const onChangeFilterText = (event) => {
        setFilterText(event.target.value)

        const aux_data = !isNullUndefinedOrEmpty(event.target.value) ? objContractList.data.filter(x =>
            x.contractName.toLowerCase().indexOf(filterText.toLowerCase()) !== -1 ||
            x.businessUnitName.toLowerCase().indexOf(filterText.toLowerCase()) !== -1 ||
            x.contractCode.toLowerCase().indexOf(filterText.toLowerCase()) !== -1) : objContractList.data

        setObjContractListFiltred && setObjContractListFiltred(prevState => ({
            ...prevState,
            data: aux_data,
            fireUpdate:true
        }))
    };

    const onFormatDate = (date) => {
        if (!date) return "";
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
    };

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                onRenderHeader={onRenderHeader}
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                {
                    inputParam_IsPanelOpen && !inputParam_ObligationHasSubLegalEntity &&
                    <Row className="pt-3">
                        <Col>
                            <MessageBox
                                inputParam_Message={ 'data-lang-msg-obligationrequiressublegalentity' }
                                inputParam_Display={ true }
                                inputParam_MessageType="warning"
                                inputParam_SetterMessage={ () => {} }
                            />
                        </Col>
                    </Row>
                }
                <Row className="pt-3">
                    <Col>
                        {
                            inputParam_IsPanelOpen && inputParam_ObligationHasSubLegalEntity && objContractListFiltred && objContractListFiltred.data &&
                            objContractListFiltred.data.map((item, index) => (
                                <Row key={item.elementId} className={`py-2`}>
                                    <Col>
                                        <div style={{fontSize: "12px", borderLeft: `10px solid`}} className='pt-2 ps-2'>
                                            <div>
                                                <TooltipHost content={ item.contractName } >
                                                    <b>{ `${item.contractName.replace("&nbsp;", " ")}` }</b>&nbsp;
                                                </TooltipHost>
                                                <div style={{fontSize: "12px"}}>
                                                    <TooltipHost content={ item.contractCode } >
                                                        <div>({ item.contractCode })</div>
                                                    </TooltipHost>
                                                </div>
                                            </div>
                                            <div>
                                                <TooltipHost content={ item.businessUnitName } >
                                                    <div>{ item.businessUnitName }</div>
                                                </TooltipHost>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xl={4} className='pt-2'>
                                        {
                                            ('activa' in item ? item.activa : (isNullOrEmpty(item.fechaPrimerVencimiento) ? false : true)) &&
                                            <>
                                                {
                                                    item.canUpdate === true &&
                                                    <>
                                                        <DatePicker
                                                            value={!isNullUndefinedOrEmpty(item.fechaPrimerVencimiento) ? new Date(item.fechaPrimerVencimiento) : null }
                                                            onSelectDate={(date) => handleDateChange(date, item.elementId)}
                                                            width={"100%"}
                                                            formatDate={onFormatDate}
                                                            styles={{ root: { width: '100%' } }}
                                                            customInput={ <CalendarCustomInput icon={<Icon iconName='Calendar' />} /> }
                                                        />
                                                        <CValidator
                                                            isInValid={item.initialValFired ? (!isNullUndefinedOrEmpty(item.activa) ? isNullOrEmpty(item.fechaPrimerVencimiento) : false) : false}
                                                            isInvalidText={"Error"}
                                                        />
                                                    </>
                                                }
                                                {
                                                    item.canUpdate === false &&
                                                    <>
                                                        <DatePicker
                                                            value={!isNullUndefinedOrEmpty(item.fechaPrimerVencimiento) ? new Date(item.fechaPrimerVencimiento) : null }
                                                            disabled={true}
                                                            width={"100%"}
                                                            formatDate={onFormatDate}
                                                            styles={{ root: { width: '100%' } }}
                                                            customInput={ <CalendarCustomInput icon={<Icon iconName='Calendar' />} /> }
                                                        />
                                                    </>
                                                }
                                            </>
                                        }
                                        {
                                            !('activa' in item ? item.activa : (isNullOrEmpty(item.fechaPrimerVencimiento) ? false : true)) &&
                                            <DatePicker
                                                disabled={true}
                                                value={null}
                                                width={"100%"}
                                                formatDate={onFormatDate}
                                                styles={{ root: { width: '100%' } }}
                                                customInput={ <CalendarCustomInput icon={<Icon iconName='Calendar' />} /> }
                                            />
                                        }
                                    </Col>
                                    <Col className='col-auto mx-auto pt-2'>
                                        {
                                            item.canDelete === true &&
                                            <Toggle
                                                checked={isNullUndefinedOrEmpty(item.activa) ? false : item.activa}
                                                onChange={() => onChangeAssociateConsolidation(item)} />
                                        }
                                        {
                                            item.canDelete === false &&
                                            <Toggle
                                                checked={isNullUndefinedOrEmpty(item.activa) ? false : item.activa}
                                                disabled={true} />
                                        }
                                    </Col>
                                </Row>
                            ))
                        }
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelVinculateObligation.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_ObligationName: PropTypes.string.isRequired,
    inputParam_ObligationId: PropTypes.number.isRequired,
    inputParam_ObligationHasSubLegalEntity: PropTypes.bool.isRequired,
};

export default SidePanelVinculateObligation;